import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Back from '../../../components/common/Back';
import { fetchRecipeDetail, toggleFavoriteMeal, addToMealPlan, clearMessage } from '../../../redux/slices/customer/recipeSlice';
import Layout from '../Layout';
import { useParams } from 'react-router-dom';
import '../../../global.css';
import iconCalories from '../../../images/icon-calories.svg';
import iconPlusAdd from '../../../images/icon-plus-add.svg';
import defaultBanner from '../../../images/img-recipe-banner.jpg';
import iconCheck from '../../../images/icon-check-recipe-ing.svg';
import showAlert from '../../../components/common/showAlert';

const RecipeDetail = () => {
  const { recipeId, category } = useParams();
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState('kcals');
  const { recipeDetail, isLoading, errorMessage, successMessage, isFavorite} = useSelector(state => state.recipes);
  
  useEffect(() => {
    dispatch(fetchRecipeDetail(recipeId)); 
  }, [dispatch, recipeId]);

  useEffect(() => {
    dispatch(clearMessage());
  }, []); 

  useEffect(() => {
    if (successMessage && successMessage !='') {
      showAlert('success', successMessage);
      dispatch(clearMessage());
    }
    if (errorMessage && errorMessage !='') {
      showAlert('error', errorMessage);
      dispatch(clearMessage());
    }
  }, [successMessage, errorMessage]);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const handleFavoriteToggle = () => {
    dispatch(toggleFavoriteMeal({
      id: recipeId,
      category: recipeDetail?.category || 'default',
    }));
  };

  const handleAddToMealPlan = () => {
    dispatch(addToMealPlan({
      id: recipeId,
      category: category || 'default',
    }));
  };

  return (
    <Layout>
      <main className="main page-add-meal">
        <header>
          <div className="main-head flex pb-0">
            <h1 className="greet-user-text">Recipes</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </div>
        </header>
        <div className="main-content flex justify-between flex-col-rev-mob">
          <div style={{ width: '100%' }}>
            <div className="col-12">
               {isLoading ? (
                <div className="loading-placeholder">Loading...</div> // Placeholder or spinner
              ) : (
                <img
                  src={recipeDetail?.meal_picture_full_url || defaultBanner}
                  alt="Recipe Banner"
                  className="img-fluid rounded"
                />
              )}
            </div>
            <div className="col-md-6 mt-4 sec-recipe-detail" style={{ display: 'inline-block', float: 'left' }}>
              <h1>{recipeDetail?.meal_name}</h1>
              <ul className="ul-recipe-details">
                <li>
                  <img src={iconCalories} alt="Calories" />
                  <span>{recipeDetail?.recipe_calories} KCAl</span>
                </li>
              </ul>
              <h4 className="title-serving mt-4">Nutrition Per Serving</h4>
              <div>
                <ul className="ul-atmm">
                  <li>
                    <button className="btn-atmm" onClick={handleAddToMealPlan}><img src={iconPlusAdd} alt="Add to mealplan" /> Add to my Meal Plan</button>
                  </li>
                  <li>
                    <i
                      className={`bi text-red cursor-pointer fs-30 ${ isFavorite ? 'bi-heart-fill' : 'bi-heart'}`}
                      onClick={handleFavoriteToggle}
                    ></i>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-6 mt-4" style={{ display: 'inline-block' }}>
              <div>
                <ul className="nav nav-pills nav-curve-tab d-inline-flex" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${selectedTab === 'kcals' ? 'active' : ''}`}
                      onClick={() => handleTabClick('kcals')}
                    >
                      {recipeDetail?.recipe_calories} KCAl
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${selectedTab === 'protein' ? 'active' : ''}`}
                      onClick={() => handleTabClick('protein')}
                    >
                      {recipeDetail?.protein} Protein
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${selectedTab === 'fat' ? 'active' : ''}`}
                      onClick={() => handleTabClick('fat')}
                    >
                      {recipeDetail?.fat} Fat
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${selectedTab === 'carbs' ? 'active' : ''}`}
                      onClick={() => handleTabClick('carbs')}
                    >
                      {recipeDetail?.carb} Carbs
                    </button>
                  </li>
                </ul>
              </div>

              <div className="tab-content mt-4" id="pills-tabContent">
                {selectedTab === 'kcals' && (
                              <div className="tab-content mt-4" id="pills-tabContent">
  <div className="tab-pane fade show active tab-pane-kcals" id="pills-kcals" role="tabpanel" aria-labelledby="pills-kcals-tab" tabindex="0">
<ul className="nav nav-pills mb-3 nav-curve-tab d-inline-flex" id="pills-tab" role="tablist">
  <li className="nav-item" role="presentation">
    <button className="nav-link active" id="pills-ingredients-tab" data-bs-toggle="pill" data-bs-target="#pills-ingredients" type="button" role="tab" aria-controls="pills-ingredients" aria-selected="true">Ingredients
</button>
  </li>
  <li className="nav-item" role="presentation">

    <button className="nav-link" id="pills-instructions-tab" data-bs-toggle="pill" data-bs-target="#pills-instructions" type="button" role="tab" aria-controls="pills-instructions" aria-selected="false" tabindex="-1">Instructions</button>
  </li>
</ul>
<div className="tab-content" id="pills-tabContent">
  <div className="tab-pane fade show active" id="pills-ingredients" role="tabpanel" aria-labelledby="pills-ingredients-tab" tabindex="0">
  <ul className="ul-recipe-ingredients">
  
  {recipeDetail?.ingredients && recipeDetail?.ingredients?.map((ingredient, index) => (          
                        <li><img src={iconCheck} alt="image" /><span>{ingredient.ingredient_name}</span></li>
                      ))}

  
  </ul>
  </div>
  <div className="tab-pane fade" id="pills-instructions" role="tabpanel" aria-labelledby="pills-instructions-tab" tabindex="0">
    {recipeDetail?.instructions}
  </div>
</div>  
 </div>
    
</div>
                )}
                {selectedTab === 'protein' && <div>{recipeDetail?.protein} g</div>}
                {selectedTab === 'fat' && <div>{recipeDetail?.fat} g</div>}
                {selectedTab === 'carbs' && <div>{recipeDetail?.carb} g</div>}
              </div>


            </div>
          </div>
        </div>
        <div style={{ height: '100px' }}></div>
      </main>
    </Layout>
  );
};

export default RecipeDetail;